import { Box, styled } from "@mui/material";

interface StyledIconProps {
  ownerState: { active?: boolean; completed?: boolean; error?: boolean };
}

export const StyledIcon = styled(Box)<StyledIconProps>(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '50%',
  width: theme.spacing(3.5),
  height: theme.spacing(3.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: theme.spacing(1),
  border: `solid 1px ${theme.palette.common.black}`,

  ...(ownerState.active && {
    fontWeight: theme.typography.fontWeightBold,
    border: `2px solid ${ownerState.error ? theme.palette.error : theme.palette.common.black}`,
  }),
}));